import PosthogService from '~/services/posthog/PosthogService';
import { JobOverviewTab } from './types';

// Event-specific interface (co-located)
export interface IPermJobOverviewTabClickedPayload {
  tabName: JobOverviewTab;
  postingId: string;
}

/**
 * Fires when user navigates between tabs on the job overview page
 * Event: dental_portal:perm_job_overview:tab_clicked
 */
export function firePermJobOverviewTabClicked(payload: IPermJobOverviewTabClickedPayload): void {
  PosthogService.getInstance().track('dental_portal:perm_job_overview:tab_clicked', {
    tab_name: payload.tabName,
    posting_id: payload.postingId,
  });
}